module.exports = {"purchase":"Purchase","makeOffer":"Make An Offer","acceptOffer":"Accept Offer","requestNetPrice":"Request Net Price","purchaseNow":"Purchase Now"}


//////////////////
// WEBPACK FOOTER
// ./json/copy/itemActionButtons.json
// module id = 2273
// module chunks = 7